import { render, staticRenderFns } from "./ContentCheck.vue?vue&type=template&id=009dd7e0&"
import script from "./ContentCheck.vue?vue&type=script&lang=ts&"
export * from "./ContentCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports